// Copyright (c) 2016 Deere & Company

import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import t from 'tcomb';

const PlanNames = t.list(KeyValuePair, 'PlanNames');

export const getDefaultState = () => new PlanNames([]);

export default PlanNames;



// WEBPACK FOOTER //
// ./src/reports/maintenance-plan/state/plan-names.js